import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";
import moment from "moment"; // Ensure moment is imported

const FaqDetail = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null); // Error state
  const history = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getFaqDetail();
    }
  }, [id]);

  const getFaqDetail = () => {
    loader(true);
    ApiClient.get(`faq/detail?id=${id}`) // Updated API endpoint
      .then((res) => {
        if (res.success) {
          setData(res.data);
        } else {
          setError("Failed to load FAQ details");
        }
        loader(false);
      })
      .catch(() => {
        setError("An error occurred while fetching FAQ details");
        loader(false);
      });
  };

  return (
    <>
      <Layout>
        <div className="wrapper_section bg-white shadow-box rounded-lg w-full p-4">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">FAQ Detail</h3>
            </div>
          </div>
          {error ? (
            <div className="text-red-500">{error}</div>
          ) : (
            <div className="flex flex-col gap-y-6">
              {/* Question */}
              <div className="col-span-12 md:col-span-6">
                <div className="">
                  <p className="flex md:items-center flex flex-col md:flex-row font-semibold capitalize">
                    <span className="inline-flex md:w-96 text-md text-gray-600">Question:</span>
                    {data?.question}
                  </p>
                </div>
              </div>

              {/* Answer */}
              <div className="col-span-12 md:col-span-6">
                <div className="">
                  <p className="flex md:items-center flex flex-col md:flex-row font-semibold">
                    <span className="inline-flex md:w-96 text-md text-gray-600 shrink-0">Answer:</span>
                    <span className="" dangerouslySetInnerHTML={{ __html: data?.answer }}></span>
                  </p>
                </div>
              </div>

              {/* Date */}
              <div className="col-span-12 md:col-span-6">
                <div className="">
                  <p className="flex md:items-center flex flex-col md:flex-row font-semibold">
                    <span className="inline-flex md:w-96 text-md text-gray-600">Date:</span>
                    {moment(data?.createdAt).format("LL")}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default FaqDetail;
